/** Port of TeaCheck/Domain/EpisodeCatalog.swift. EP1 is free; EP2–EP5 require Premium. */
export interface CatalogEntry {
  id: string;
  episodeCode: string;
  title: string;
  clientName: string;
  avatarAssetName: string;
  mapStatusText: string;
  requiresPremium: boolean;
}

export const EPISODE_CATALOG: CatalogEntry[] = [
  { id: 'episode_1_same_spot_thursday', episodeCode: 'EP 01', title: 'Same Spot Thursday', clientName: 'Cindy', avatarAssetName: 'cindy-parker-avatar-v2', mapStatusText: "my boyfriend disappears every thursday. he swears it's work.", requiresPremium: false },
  { id: 'episode_2_read_the_room_babe', episodeCode: 'EP 02', title: 'Read the Room, Babe', clientName: 'Maya', avatarAssetName: 'maya-rivera-avatar', mapStatusText: "my boyfriend's phone buzzed 9 times. he flipped it face down 🙄", requiresPremium: true },
  { id: 'episode_3_double_booked', episodeCode: 'EP 03', title: 'Double Booked', clientName: 'Jordan', avatarAssetName: 'jordan-reyes-avatar', mapStatusText: 'my fiancée is a night nurse. the hospital has never heard of her.', requiresPremium: true },
  { id: 'episode_4_the_vanishing_groom', episodeCode: 'EP 04', title: 'The Vanishing Groom', clientName: 'Priya', avatarAssetName: 'ep4_portraits_priya_v2', mapStatusText: 'my fiancé vanished on our wedding day. he left his phone behind.', requiresPremium: true },
  { id: 'episode_5_last_seen_in_miami', episodeCode: 'EP 05', title: 'Last Seen in Miami', clientName: 'Avery', avatarAssetName: 'ep5_avatar_avery', mapStatusText: "my sister is missing in Miami. so who's posting on her account?", requiresPremium: true },
];
/** title and mapStatusText are i18n keys (same English source strings as Swift's L()). */
export const DEFAULT_EPISODE_ID = 'episode_1_same_spot_thursday';

export const DEFAULT_VISIBLE_EPISODE_IDS = new Set([
  'episode_1_same_spot_thursday',
  'episode_2_read_the_room_babe',
  'episode_3_double_booked',
]);

export const GATE_REQUEST_BY_EPISODE: Record<string, string> = {
  episode_1_same_spot_thursday: 'r5_planned_meetup',
  episode_2_read_the_room_babe: 'r5_snap_streak',
  episode_3_double_booked: 'r5_purple_saturday',
  episode_4_the_vanishing_groom: 'ep4_r01',
  episode_5_last_seen_in_miami: 'ep5_r04',
};
